export const theme = {
    colors: {
        primary: '#e67e22',
        primaryDark: '#d35400',
        primaryLight: '#f39c12',
        secondary: '#2c3e50',
        success: '#27ae60',
        danger: '#e74c3c',
        warning: '#f39c12',
        background: '#f0f2f5',
        card: '#ffffff',
        text: '#2d3436',
        textLight: '#636e72',
        textMuted: '#b2bec3',
        border: '#dfe6e9',
        sidebar: '#1a1a2e',
        sidebarHover: '#16213e',
        shadow: 'rgba(0,0,0,0.08)'
    },
    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px',
        xxl: '48px'
    },
    borderRadius: {
        sm: '4px',
        md: '8px',
        lg: '12px',
        xl: '16px',
        round: '50%'
    },
    shadows: {
        sm: '0 1px 3px rgba(0,0,0,0.06)',
        md: '0 2px 8px rgba(0,0,0,0.08)',
        lg: '0 4px 16px rgba(0,0,0,0.12)',
        xl: '0 8px 32px rgba(0,0,0,0.16)',
        glow: '0 0 20px rgba(230, 126, 34, 0.3)'
    },
    breakpoints: {
        mobile: '480px',
        tablet: '768px',
        desktop: '1024px'
    },
    fonts: {
        primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        heading: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
    }
};